import * as $runtime from "../runtime.js";
import * as Control$dApplicative from "../Control.Applicative/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import {focusElement, focusNode} from "./foreign.js";
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const asyncRequest = /* #__PURE__ */ Specular$dFRP$dAsync.asyncRequest(Specular$dInternal$dRIO.monadEffectRIO)(monadFRP);
const dynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.dynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const newCallback = /* #__PURE__ */ Specular$dCallback.newCallback()(Specular$dInternal$dRIO.monadEffectRIO);
const holdDyn = /* #__PURE__ */ Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const attachEvent = /* #__PURE__ */ Specular$dCallback.attachEvent()(monadFRP);
const subscribeDyn_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeDyn_(monadFRP);
const withPrevious = dictMonadFRP => {
  const bind1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind;
  const readDynamic = Specular$dFRP$dBase.readDynamic(dictMonadFRP.MonadEffect0());
  const foldDyn = Specular$dFRP$dBase.foldDyn(dictMonadFRP);
  return source => bind1(readDynamic(source))(initial => foldDyn($$new => old => ({previous: Data$dMaybe.$Maybe("Just", old.current), current: $$new}))({
    previous: Data$dMaybe.Nothing,
    current: initial
  })(source));
};
const withLoadedSuccessE$p = dictShow => loader => errorHandler => request => handler => Specular$dInternal$dRIO.bindImpl(asyncRequest((() => {
  const n = Specular$dInternal$dIncremental.constant(request);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})()))(result => dynamic_(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v.tag === "NotRequested") { return Specular$dInternal$dRIO.pureImpl(); }
  if (v.tag === "Loading") { return loader; }
  if (v.tag === "Loaded") {
    if (v._1.tag === "Left") { return errorHandler(v._1._1); }
    if (v._1.tag === "Right") { return handler(v._1._1); }
    $runtime.fail();
  }
  $runtime.fail();
})(result)));
const withLoadedSuccessE = dictShow => withLoadedSuccessE$p(dictShow)(Specular$dInternal$dRIO.pureImpl());
const withLoadedSuccess$p = loader => errorHandler => request => handler => Specular$dInternal$dRIO.bindImpl(asyncRequest((() => {
  const n = Specular$dInternal$dIncremental.constant(request);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})()))(result => dynamic_(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v.tag === "NotRequested") { return Specular$dInternal$dRIO.pureImpl(); }
  if (v.tag === "Loading") { return loader; }
  if (v.tag === "Loaded") {
    if (v._1.tag === "Left") { return errorHandler(v._1._1); }
    if (v._1.tag === "Right") { return handler(v._1._1); }
    $runtime.fail();
  }
  $runtime.fail();
})(result)));
const waitUntil = dictMonadFRP => canRun => e => Specular$dInternal$dRIO.bindImpl(newCallback)(pushToQueue => Specular$dInternal$dRIO.bindImpl(holdDyn(Data$dMaybe.Nothing)(pushToQueue.event))(isWaiting => Specular$dInternal$dRIO.bindImpl(newEvent)(result => Specular$dInternal$dRIO.bindImpl(attachEvent(Specular$dFRP$dBase.functorEvent.map(Data$dMaybe.Just)(e))(pushToQueue.callback))(() => Specular$dInternal$dRIO.bindImpl(subscribeDyn_(v => {
  const $0 = (() => {
    if (v._2.tag === "Just") {
      const $0 = result.fire(v._2._1);
      return () => {
        $0();
        return pushToQueue.callback(Data$dMaybe.Nothing)();
      };
    }
    if (v._2.tag === "Nothing") { return () => {}; }
    $runtime.fail();
  })();
  if (v._1) { return $0; }
  return () => {};
})(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dTuple.Tuple)(canRun))(isWaiting)))(() => Specular$dInternal$dRIO.pureImpl(result.event))))));
const unlinesWidget = /* #__PURE__ */ (() => {
  const $0 = Data$dFoldable.traverse_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableArray)(Data$dFoldable.identity);
  const $1 = [Specular$dDom$dBuilder$dClass.el_(Specular$dDom$dBuilder.monadDomBuilderBuilder)("br")];
  const $2 = Data$dFunctor.arrayMap(Control$dApplicative.applicativeArray.pure);
  return x => $0(Data$dFoldable.foldlArray(v => v1 => {
    if (v.init) { return {init: false, acc: v1}; }
    return {init: false, acc: Data$dSemigroup.concatArray(v.acc)(Data$dSemigroup.concatArray($1)(v1))};
  })({init: true, acc: []})($2(x)).acc);
})();
const times = "×";
const timesIcon = /* #__PURE__ */ (() => Specular$dDom$dBuilder.monadDomBuilderBuilder.text("×"))();
const simpleErrorWidget = err => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBuilder.monadDomBuilderBuilder.text("Error loading data"))(() => Specular$dDom$dBuilder.monadDomBuilderBuilder.elAttr("pre")(Foreign$dObject.empty)(Specular$dDom$dBuilder.monadDomBuilderBuilder.text(err)));
const withLoadedSuccess = /* #__PURE__ */ withLoadedSuccess$p(/* #__PURE__ */ Specular$dInternal$dRIO.pureImpl())(simpleErrorWidget);
const nbsp = /* #__PURE__ */ (() => Specular$dDom$dBuilder.monadDomBuilderBuilder.text(" "))();
const classesFromString = /* #__PURE__ */ (() => {
  const $0 = Data$dArray.filter(x => x !== "");
  const $1 = Data$dFunctor.arrayMap(Data$dString$dCommon.trim);
  const $2 = Data$dString$dCommon.split(" ");
  return x => Specular$dDom$dElement.classes($0($1($2(x))));
})();
export {
  asyncRequest,
  attachEvent,
  classesFromString,
  dynamic_,
  holdDyn,
  monadFRP,
  nbsp,
  newCallback,
  newEvent,
  simpleErrorWidget,
  subscribeDyn_,
  times,
  timesIcon,
  unlinesWidget,
  waitUntil,
  withLoadedSuccess,
  withLoadedSuccess$p,
  withLoadedSuccessE,
  withLoadedSuccessE$p,
  withPrevious
};
export * from "./foreign.js";
